import { Box } from "@chakra-ui/react";
import { IRankingExtendedSearch } from "src/api/server/extended-search";
import { Container } from "src/components/layout/container";
import { useUserStore } from "src/stores/user-store";
import { DownloadButton } from "./components/download-button/download-button";
import { RankingsDropdownSelector } from "./components/rankings-dropdown-selector/rankings-dropdown-selector";
import { SortDirectionButton } from "./components/sort-direction-button/sort-direction-button";
import { ISelectedRanking } from "./components/types";
import { ISearch } from "./search.types";
import { handleSortDirection, handleSortingChange } from "./store/actions";
import { useSearchStore } from "./store/search-store";

interface ISortSectionProps extends ISearch {
    resultCount: number | null;
    rankings: ReadonlyArray<IRankingExtendedSearch>;
    relevanceRanking: IRankingExtendedSearch;
    userNumOfDownloads: number;
}

export const SortSection = ({ resultCount, rankings, relevanceRanking, userNumOfDownloads, onSearch }: ISortSectionProps) => {
    const { sortDirection, selectedRanking } = useSearchStore();
    const { isLoggedIn } = useUserStore();

    const hasResults = resultCount !== null;
    const isDefaultRankingSelected = selectedRanking.id === null;

    const onClickSortDirection = () => {
        handleSortDirection({ onSearch });
    };

    const onSortingChange = ({ id, sortDirection: direction }: ISelectedRanking) => {
        handleSortingChange({ sortByRankingId: id, sortDirection: direction, onSearch });
    };

    return (
        <Container as="section" pt={[2, 5]} pb={[3, 5]}>
            <Box display="flex" flexFlow="column">
                <Box display="flex">
                    <Box width={["100%", "250px"]} mr={2}>
                        <RankingsDropdownSelector
                            rankings={rankings}
                            relevanceRanking={relevanceRanking}
                            selectedRanking={selectedRanking}
                            isDisabled={!hasResults}
                            onChange={onSortingChange}
                        />
                    </Box>
                    <SortDirectionButton
                        onClick={onClickSortDirection}
                        isDisabled={!hasResults || isDefaultRankingSelected}
                        sortDirection={sortDirection}
                        alignSelf="center"
                    />
                    {isLoggedIn && <DownloadButton userNumOfDownloads={userNumOfDownloads} />}
                </Box>
            </Box>
        </Container>
    );
};
